import type { TaxClosingPeriodItem } from "@/services/tax-closing-period";

export type MonthView =
  | { kind: "real"; data: TaxClosingPeriodItem }
  | { kind: "placeholder"; month: number; year: number };

export type DialogAction = "release" | "block" | null;

export interface MonthStats {
  released: number;
  blocked: number;
  closed: number;
  placeholder: number;
}

export function getMonthYear(view: MonthView): {
  month: number;
  year: number;
} {
  return view.kind === "real"
    ? { month: view.data.month, year: view.data.year }
    : { month: view.month, year: view.year };
}
